import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    standalone: true,
    imports: [MatButtonModule],
    templateUrl: './error.component.html',
    styleUrls: ['./error.component.scss'],
})
export class ErrorComponent {
    readonly message = this.resolveMessage();
    private readonly router: Router = inject(Router);

    goHome(): void {
        this.router.navigate(['/']);
    }

    private resolveMessage(): string {
        const state = history.state as { message?: unknown } | null;
        const message = state?.message;

        if (typeof message === 'string' && message.trim()) {
            return message;
        }

        return 'An unexpected error occurred.';
    }
}
